import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export default function ComboBox({ name, label, options = [], value, onChange, disabled = false, state, onBlur, required, inputRef }) {
  console.log(value, 'value');
  console.log(options, 'options');
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Autocomplete
        // openOnFocus
        // open={open == true}
        // onOpen={() => setOpen(true)}
        // onClose={() => setOpen(false)}
        id={name}
        disabled={disabled}
        size="small"
        getOptionLabel={(option) => option.option?.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
        value={
          (options && name === 'district'
            ? options.find((option) => option.value.replace(/\s+/g, '').toLowerCase() === value.replace(/\s+/g, '').toLowerCase())
            : options.find((option) => option.value === value)) || null
        }
        onChange={(event, newValue) => {
          onChange(event, newValue);
          setOpen(false);
        }}
        onBlur={onBlur}
        options={Array.isArray(options) ? options : []}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            inputRef={inputRef}
            error={state?.errorStatus[name] === true ? true : false}
            required={required}
            sx={{
              '.MuiFormLabel-asterisk': {
                color: '#e55353',
                fontSize: '20px',
                fontWeight: 700,
              },
            }}
            onClick={() => setOpen(true)}
            onBlur={() => setOpen(false)}
          />
        )}
      />
      <Typography
        sx={{
          marginTop: '2px',
          marginLeft: '10px',
          marginBottom: '0px',
          fontSize: '11px',
          color: 'danger.main',
        }}
      >
        {state?.errorFields[name]}
      </Typography>
    </>
  );
}
